import React from "react";
import styled from "styled-components";
import { Environment } from "@core/config/environment";
import { LockIcon } from "@ui/components/icons";
import { row } from "@ui/components/layout";

type ClosedGroupIllustrationProps = React.HTMLAttributes<HTMLDivElement>;

export const ClosedGroupIllustration: React.FC<ClosedGroupIllustrationProps> = ({ ...htmlProps }) => {
	return (
		<Container {...htmlProps}>
			<LockIcon />
		</Container>
	);
};

const Container = styled.div`
	background-color: ${({ theme }) =>
		Environment.APP_VARIANT === "jaangal" ? theme.colors.primaryLight : theme.colors.lightBlue};
	width: 24px;
	height: 24px;
	border-radius: 12px;
	${row(0, "center", "center")};

	> svg {
		path {
			fill: ${({ theme }) => theme.colors.secondary};
		}
		width: 10px;
	}
`;
